var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyebrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.46 84.91"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.71 2v28.13c-37.28 0-71.28 10-101.32 26.69a206.51 206.51 0 00-27.65 18.31l-2.85 2.29c-2.61 2.15-4.52 3.86-5.7 5l-.54.52L1.75 63c8-8 22.51-19.44 43-30.81C77.35 14.08 114.21 2.9 154.64 2z",
    stroke: "#ecb989",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    "data-name": "Ebene 2"
  })));
}
export default __webpack_public_path__ + "5f0276105dda5e19d55e64545f9fee0f.svg";
export { SvgEyebrowLeft as ReactComponent };